export enum Area {
    NaoInformado = 0,
    Urbana = 1,
    Rural = 2
}